import { createContext } from "react";

export const XRouterNavigateContext = createContext(null);
